// Logique pure des écrans des achats (lot L4-C) : libellés, tons des états, actes possibles d'une
// consultation selon son état et les droits, montants en francs CFA avec la mention fictive.
import { ETATS_COMMANDE, ETATS_CONSULTATION, ETATS_CONTRAT, ETATS_OFFRE, type EtatCommande, type EtatConsultation, type EtatContrat, type EtatOffre } from '@cc/contrats';
import type { TonEtat } from '@cc/ui';

export function francs(n: number, fictif = false): string {
  return `${n.toLocaleString('fr-FR')} F${fictif ? ' (fictif)' : ''}`;
}

export const libelleConsultation = (e: EtatConsultation) => ETATS_CONSULTATION[e];
export const libelleOffre = (e: EtatOffre) => ETATS_OFFRE[e];
export const libelleContrat = (e: EtatContrat) => ETATS_CONTRAT[e];
export const libelleCommande = (e: EtatCommande) => ETATS_COMMANDE[e];

export const TON_CONSULTATION: Record<EtatConsultation, TonEtat> = { preparation: 'attente', publiee: 'attente', analyse: 'signer', attribuee: 'ok', infructueuse: 'neutre', annulee: 'neutre' };
export const TON_OFFRE: Record<EtatOffre, TonEtat> = { recue: 'attente', ecartee: 'retard', retenue: 'ok', non_retenue: 'neutre' };
export const TON_CONTRAT: Record<EtatContrat, TonEtat> = { a_signer: 'signer', signe: 'ok', termine: 'neutre', resilie: 'retard' };
export const TON_COMMANDE: Record<EtatCommande, TonEtat> = { emise: 'attente', livree_partiellement: 'attente', livree: 'ok', annulee: 'neutre' };

export interface DroitsAchats {
  modifier: boolean;
  valider: boolean;
  decider: boolean;
  signer: boolean;
}

export type ActeConsultation = 'publier' | 'offre' | 'analyse' | 'analyser' | 'attribuer' | 'contrat' | 'infructueuse' | 'annuler';

/** Actes proposés sur une consultation (le serveur refait tous les contrôles). */
export function actesConsultation(c: { etat: EtatConsultation; offres: { conforme: boolean | null }[]; contrat_id: string | null }, d: DroitsAchats): ActeConsultation[] {
  const a: ActeConsultation[] = [];
  if (c.etat === 'preparation' && d.modifier) a.push('publier', 'annuler');
  if (c.etat === 'publiee' && d.modifier) {
    a.push('offre');
    if (c.offres.length > 0) a.push('analyse');
    a.push('infructueuse');
  }
  if (c.etat === 'analyse') {
    if (d.valider) a.push('analyser');
    if (d.decider && c.offres.some((o) => o.conforme === true)) a.push('attribuer');
    if (d.modifier) a.push('infructueuse');
  }
  if (c.etat === 'attribuee' && !c.contrat_id && d.modifier) a.push('contrat');
  return a;
}

/** Date du jour à Libreville (AAAA-MM-JJ). */
export function aujourdhui(maintenant = new Date()): string {
  return new Date(maintenant.getTime() + 3_600_000).toISOString().slice(0, 10);
}
